export function formatPrice(value, lang = 'tr-TR') {
    const num = Number(value) || 0;

    const locale =
        String(lang).startsWith('ar-AE') ? 'ar-EG-u-nu-arab' : 'tr-TR-u-nu-latn';

    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(num);
}